module.exports = __webpack_public_path__ + "static/img/logo.d0a8fc6c.png";